<template>
    <div class="row">
        <div class="col-12" data-aos="fade-up" data-aos-duration="600" data-aos-delay="150">
            <div class="w-100">

                <div class="checkout-container-row-2__inputs">
                    <div class="double-input-select" v-if="billing.data.type == 'company'">
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="text" v-model="billing.data.name" @focus="validation.billing.name.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.name.state == false}">{{validation.billing.name.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('company_name')}}
                            </label>
                        </div>
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="text" v-model="billing.data.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.fiscal_code.state == false}">{{validation.billing.fiscal_code.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('vat')}}
                            </label>
                        </div>
                    </div>

                    <div class="double-input-select" v-if="billing.data.type == 'company'">
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="email" v-model="billing.data.pec" @focus="validation.billing.pec.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.pec.state == false}">{{validation.billing.pec.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('pec')}}
                            </label>
                        </div>
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="text" v-model="billing.data.sdi" @focus="validation.billing.sdi.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.sdi.state == false}">{{validation.billing.sdi.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('sdi')}}
                            </label>
                        </div>
                    </div>

                    <div class="double-input-select" v-if="billing.data.type == 'company'">
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="email" v-model="billing.data.address" @focus="validation.billing.address.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.address.state == false}">{{validation.billing.address.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('address')}}
                            </label>
                        </div>
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="text" v-model="billing.data.city" @focus="validation.billing.city.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.city.state == false}">{{validation.billing.city.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('city')}}
                            </label>
                        </div>
                    </div>

                    <div class="double-input-select" v-if="billing.data.type == 'company'">
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between ">
                            <v-select
                                @input="validation.billing.province.state = null"
                                v-model="billing.data.province"
                                :class="{'full' : (billing.data.province != null && billing.data.province != '')}"
                                :options="provinces"
                                label="value"
                                index="label"
                                :reduce="label => label.label"
                            >
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        {{$root.translateString('no_results')}} <strong>{{ search }}</strong>
                                    </template>
                                </template>
                                <template slot="option" slot-scope="option">
                                    {{ option.value }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="flex">
                                        <div class="w-100">
                                            {{ option.value }}
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                            <label class="placeholder">
                                {{$root.translateString('province')}}
                            </label>
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.province.state == false}">{{validation.billing.province.message}}</div>
                        </div>
                        <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                            <input placeholder=" " type="email" v-model="billing.data.cap" @focus="validation.billing.cap.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.cap.state == false}">{{validation.billing.cap.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('cap')}}
                            </label>
                        </div>
                    </div>

                    <div class="full-input" v-if="billing.data.type != 'company'">
                        <div class="full-input__field-gr">
                            <input placeholder=" " type="text" v-model="billing.data.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                            <div class="invalid-feedback" :class="{'d-block' : validation.billing.fiscal_code.state == false}">{{validation.billing.fiscal_code.message}}</div>
                            <label class="full-input__after-input">
                                {{$root.translateString('fiscal_code')}}
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            <div class="w-100">
                <div class="checkout-container-row-2__checkbox mt-2 mt-2">
                    <div class="checkbox-styles">
                        <div class="checkbox">
                            <input type="checkbox" id="require_invoice" class="cb" name="require_invoice" v-model="billing.require_invoice">
                            <label for="require_invoice"></label>
                        </div>
                        <div class="checkbox-styles__link checkbox-link-js checkout" @click="billing.require_invoice = !billing.require_invoice">
                            <span>{{$root.translateString('always_ask_for_invoice')}}</span>
                        </div>
                    </div>
                </div>
                <div class="brand-btn mt-5 mb-5">
                    <a href="javascript:void(0)" @click="updateBilling" class="full py-2 text-center">
                        <span class="my-1">
                             {{$root.translateString('save-edits')}}
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['lang', 'userProp', 'provinces'],
    data() {
        return {
            billing: {
                require_invoice: false,
                data: {
                    type: 'company',
                    name: '',
                    fiscal_code: '',
                    sdi: '',
                    pec: '',
                    address: '',
                    city: '',
                    cap: '',
                    province: ''
                }
            },
            show_password_confirmation: false,
            show_password: false,
            loading: false,
            validation:{
                billing: {
                    name: {
                        state: null,
                        message: '',
                    },
                    fiscal_code: {
                        state: null,
                        message: '',
                    },
                    sdi: {
                        state: null,
                        message: '',
                    },
                    pec: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    },
                },
            },
        }
    },
    mounted() {
        if(this.userProp && this.userProp.billing != null) {
            this.$set(this.billing, 'require_invoice', this.userProp.billing.require_invoice);
            this.$set(this.billing.data, 'type', this.userProp.billing.data.type);
            this.$set(this.billing.data, 'name', this.userProp.billing.data.name);
            this.$set(this.billing.data, 'fiscal_code', this.userProp.billing.data.fiscal_code);
            this.$set(this.billing.data, 'sdi', this.userProp.billing.data.sdi);
            this.$set(this.billing.data, 'pec', this.userProp.billing.data.pec);
            this.$set(this.billing.data, 'address', this.userProp.billing.data.address);
            this.$set(this.billing.data, 'city', this.userProp.billing.data.city);
            this.$set(this.billing.data, 'cap', this.userProp.billing.data.cap);
            this.$set(this.billing.data, 'province', this.userProp.billing.data.province);
        }
    },
    methods: {
        updateBilling() {

            let is_invalid = false;

            Object.keys(this.validation.billing).forEach((elem, key) => {
                this.validation.billing[elem].message = '';
                this.validation.billing[elem].state = null;
            });

            if(this.billing.data.type == 'company') {

                $.each(this.billing.data, (key, elem) => {
                    if(elem == '' && key != 'sdi' && key != 'pec'){
                        if(this.lang == 'it') {
                            this.validation.billing[key].message = 'Il campo è obbligatorio';
                        }else{
                            this.validation.billing[key].message = 'This field is required';
                        }
                        this.validation.billing[key].state = false;
                        is_invalid = true;
                    }
                });

                if(this.billing.data.sdi == '' && this.billing.data.pec == '') {
                    if(this.lang == 'it') {
                        this.validation.billing.pec.message = 'Compila PEC o Codice univoco';
                        this.validation.billing.sdi.message = 'Compila PEC o Codice univoco';
                    }else{
                        this.validation.billing.pec.message = 'Either one between PEC or SDI is required';
                        this.validation.billing.sdi.message = 'Either one between PEC or SDI is required';
                    }
                    this.validation.billing.pec.state = false;
                    this.validation.billing.sdi.state = false;

                    is_invalid = true;
                }

            }else{
                if(this.billing.data.fiscal_code == '') {
                    if(this.lang == 'it') {
                        this.validation.billing.fiscal_code.message = 'Il campo è obbligatorio';
                    }else{
                        this.validation.billing.fiscal_code.message = 'This field is required';
                    }
                    this.validation.billing.fiscal_code.state = false;
                    is_invalid = true;
                }
            }

            if(!is_invalid) {

                this.loading = true;

                axios.post('/api/user/billing-update', this.billing).then((response) => {
                    if(response.data.success == true) {

                        this.loading = false;
                        let message = '';

                        if(this.lang == 'it') {
                            message = 'Dati fatturazione aggiornati correttamente.';
                        }else{
                            message = 'Your billing information have been successfully successfully updated.';
                        }

                        this.$eventHub.$emit('notification', {
                            type: 'success',
                            message: message,
                            time: 10
                        });
                    }

                })
                    .catch( e =>  {
                        console.log(e);
                        let message = '';

                        if(this.lang == 'it') {
                            message = 'Errore durante il salvataggio, ti preghiamo di riprovare.';
                        }else{
                            message = 'An error occured while saving, please retry.';
                        }

                        this.$eventHub.$emit('notification', {
                            type: 'error',
                            message: message,
                            time: 10
                        });
                    });

            } else {
                this.loading = false;

            }

        }
    },
    beforeDestroy() {
    },
    computed: {
    }
}
</script>
